import React from 'react';
import { useEffect, useState } from 'react';
import { useNavigate, Link } from "react-router-dom";
import $, { get } from 'jquery';
import Modal from "react-modal";
import { withRouter } from '../utils/withRouter';

import { Sidebar, Menu, MenuItem } from 'react-pro-sidebar';
// import { Sidebar, Menu, MenuItem } from 'react-pro-sidebar';
import { Home } from '@mui/icons-material';
import { useLocation } from "react-router-dom";

const ExhibitionDrawer = ({ head, userId }) => {
  const history = useNavigate();
  const navigate = useNavigate();

  const [isOpen, setIsOpen] = useState(false)
  const [loginAccesslist, setLoginAccesslist] = useState([])

  //toggle model for logout.................................
  const toggleModal = () => {
    setIsOpen(!isOpen)
  }

  const loadScripts = () => {
    // This array contains all the files/CDNs 
    // const dynamicScripts = [
    //   'js/jquery.sticky.js',
    //   'js/metisMenu.min.js',
    //   'js/metisMenu-active.js',
    //   'js/main.js'
    // ];

    // for (let i = 0; i < dynamicScripts.length; i++) {
    //   const node = document.createElement('script');
    //   node.src = dynamicScripts[i];
    //   node.type = 'text/javascript';
    //   node.async = false;
    //   document.getElementsByTagName('head')[0].appendChild(node);
    // }
  }
  const logout = () => {
    sessionStorage.clear()
    navigate('/')
  }
  useEffect(() => {
    loadScripts();
    const loginDataStr = sessionStorage.getItem('loginDataSS');
    if (loginDataStr) {
      try {
        const loginData = JSON.parse(loginDataStr);
        if (loginData && loginData['loginAccesslist']) {
          setLoginAccesslist(loginData['loginAccesslist']);
        }
      } catch (e) {
        console.error("Error parsing loginDataSS", e);
      }
    }

    const sidebar = document.querySelector('.app-sidebar');
    if (sidebar) {
      const handleScroll = (e) => {
        sessionStorage.setItem("drawerScrollPos", e.target.scrollTop);
      };
      sidebar.addEventListener('scroll', handleScroll);

      // Small timeout to ensure DOM is ready and submenus are expanded
      setTimeout(() => {
        const scrollPos = sessionStorage.getItem("drawerScrollPos");
        if (scrollPos) {
          sidebar.scrollTop = parseInt(scrollPos, 10);
        }
      }, 150);

      return () => sidebar.removeEventListener('scroll', handleScroll);
    }
  }, []);

  const location = useLocation();

  useEffect(() => {
    // Keep submenu open if active
    setTimeout(() => {
      // Remove active class from all links first to reset state
      document.querySelectorAll('.side-menu a, .side-menu__item').forEach(el => {
        el.classList.remove('active');
      });
      document.querySelectorAll('.slide').forEach(el => {
        el.classList.remove('is-expanded');
      });

      const allLinks = document.querySelectorAll('.side-menu a');
      allLinks.forEach(link => {
        const href = link.getAttribute('href');
        if (href && (href === location.pathname || href === '#' + location.pathname)) {
          // Highlight the active link (the <a> with side-menu__item might be a child of the <Link> <a>)
          if (link.classList.contains('side-menu__item')) {
            link.classList.add('active');
          } else {
            const item = link.querySelector('.side-menu__item') || link;
            item.classList.add('active');
          }

          // Open parent collapse menu if it's nested
          const collapseParent = link.closest('.collapse');
          if (collapseParent) {
            collapseParent.classList.add('show');
            const toggleBtn = document.querySelector(`[href="#${collapseParent.id}"]`);
            if (toggleBtn) {
              toggleBtn.setAttribute('aria-expanded', 'true');
              toggleBtn.classList.add('active'); // Restoring this!

              // Add is-expanded to parent list item for theme styling
              const slideParent = toggleBtn.closest('.slide');
              if (slideParent) {
                slideParent.classList.add('is-expanded');
              }
            }
          } else {
            // For top-level items like Dashboard
            const slideParent = link.closest('.slide');
            if (slideParent) {
              slideParent.classList.add('is-expanded');
            }
          }
        }
      });
    }, 100);
  }, [location.pathname]);


  useEffect(() => {
    const allowedPaths = ["/hallMasterAU"];
    if (!allowedPaths.includes(location.pathname)) {
      sessionStorage.removeItem("ExhibitionHall")
      sessionStorage.removeItem("hallNameHall")
      sessionStorage.removeItem("ExhibitionOtherAreaIDHall")
    }
  }, [location.pathname]);

  const onRedirect = (path) => {
    history.push({ pathname: path, state: { 'isSearchClear': true } });
  }

  const [collapsed, setCollapsed] = useState(true);

  const handleToggleSidebar = () => {
    setCollapsed(!collapsed);
  }

  const getModuleAccess = (ModuleID) => {
    const moduleAccess = loginAccesslist.find((item) => item.ModuleID == ModuleID);
    if (moduleAccess) {
      return moduleAccess.ReadAccess;
    } else {
      return false
    }
    return false;
  };

  return (
    <>
      <style>{`
        .side-menu__item { border-bottom: 1px solid rgba(255,255,255,0.1); }
        ul.sub-menu li .side-menu__item { 
           border-bottom: 1px solid rgba(255,255,255,0.05) !important;
           padding-left: 12px !important;
           height: auto !important;
           padding-top: 8px !important;
           padding-bottom: 8px !important;
           display: flex !important;
           align-items: flex-start !important;
           justify-content: flex-start !important;
           text-align: left !important;
        }
        ul.sub-menu li .side-menu__item .side-menu__label {
           white-space: normal !important;
           word-break: break-word !important;
           line-height: 1 !important;
           text-align: left !important;
           display: flex !important;
           align-items: flex-start !important;
           justify-content: flex-start !important;
           width: 100% !important;
           margin-left: 0 !important;
           padding-left: 0 !important;
        }
        a[aria-expanded="true"] .drop-icon {
           transform: rotate(90deg);
        }
        .drop-icon {
           transition: transform 0.2s ease-in-out;
        }
        .collapse.show > .sub-menu { display: block; }
      `}</style>
      <Modal isOpen={isOpen} onRequestClose={e => toggleModal()}>
        <div className="modal-dialog custom_modal_dialog" >
          <div className="modal-content confirm-logout
" style={{ borderRadius: '0px' }}>
            <div class="modal-header">
              <h5 class="modal-title modal_title_text">Confirm Logout</h5>
              {/* <button type="button" class="close modal-close" data-dismiss="modal" onClick={this.toggleModal}>&times;</button> */}
              <button type="button " class="close pop-close text-dark" data-dismiss="modal" onClick={e => toggleModal()} ><span aria-hidden="true" class="pop-cancel">&times;</span></button>

            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-md-12">
                  <h3 class="pop_label">Do you really want to logout?</h3>
                </div>
              </div>
            </div>

            <div class="row ">
              <div class="col-md-12">
                <div class="form-group text-right mod-fot">
                  <a class="btn save_btn del-pop-save" onClick={logout}> Yes</a>
                  <a class="btn cancel_btn del-pop-cancel" data-dismiss="modal"
                    style={{ marginLeft: '5px' }} onClick={toggleModal}> No</a>
                </div>
              </div>
            </div>

          </div>
        </div>
      </Modal>
      <div className="sticky">
        <div className="app-sidebar__overlay" data-bs-toggle="sidebar" />
        <div className="app-sidebar ps ps--active-y" style={{ zIndex: 999 }}>
          <div className="side-header top-logo-almnt" style={{ width: '214px' }}>
            <a className="header-brand1" href="index.html">
              <img
                src={`${sessionStorage.getItem('ExhibitionLogoSS')}`}
                className="header-brand-img light-logo"
                alt="logo"
                style={{ width: '40px' }}
              />
              {/* <img src="http://103.25.126.207:8104/document/Exhibition/logo_banner/3/Logo_3.png" 
              class="header-brand-img header-brand-img-1 light-logo1" 
              alt="top-left logo">
              </img> */}
              <img
                src={`${sessionStorage.getItem('ExhibitionLogoSS')}`}
                className="header-brand-img light-logo1"
                alt="logo"
                // style={{ width: '110px' }}
                style={{ width: '100%' }}
              />
            </a>
            {/* LOGO */}
          </div>
          <div className="main-sidemenu pt-2">
            <div className="slide-left disabled d-none" id="slide-left">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="#7b8191"
                width={24}
                height={24}
                viewBox="0 0 24 24"
              >
                <path d="M13.293 6.293 7.586 12l5.707 5.707 1.414-1.414L10.414 12l4.293-4.293z" />
              </svg>
            </div>
            <ul className="side-menu text-left" style={{ marginRight: '0px' }}>
              {/* A - Agent Entry */}

              {/* D - Dashboard */}
              {getModuleAccess('1') &&
                <li className="slide">
                  <Link to='/dashboard' >
                    <a className="side-menu__item has-link" data-bs-toggle="slide">
                      <span className="side-menu__label">
                        Dashboard
                      </span>
                    </a>
                  </Link>
                </li>
              }

              {getModuleAccess('8') &&
                <li className="slide">
                  <Link to='/agentlist' >
                    <a className="side-menu__item">
                      <span className="side-menu__label">
                        Agent Entry
                      </span>
                    </a>
                  </Link>
                </li>
              }
              {getModuleAccess('1') &&
                <li className="slide" >
                  <a style={{ marginLeft: '0px', paddingLeft: '0px' }}
                    className="side-menu__item"
                    data-bs-toggle="collapse"
                    href="#accountsCollapse"
                    aria-expanded="false"
                    aria-controls="accountsCollapse"
                  >
                    <span className="side-menu__label w-100 d-flex justify-content-between align-items-center">
                      Accounts
                      <i className="fa fa-angle-right drop-icon" aria-hidden="true" style={{ marginRight: "8px" }}></i>
                    </span>
                  </a>
                  <div className="collapse " id="accountsCollapse">
                    <ul className="flex-column sub-menu" style={{ marginRight: '0px' }}>
                      {getModuleAccess('37') &&
                        <li className="slide">  <Link to='/agentReceiptList'>
                          <a className="side-menu__item">
                            <span className="side-menu__label">
                              Agent Receipt
                            </span>
                          </a></Link>
                        </li>
                      }
                      {getModuleAccess('38') &&
                        <li className="slide">  <Link to='/ddReturnList'>
                          <a className="side-menu__item">
                            <span className="side-menu__label">
                              DD Return
                            </span>
                          </a></Link>
                        </li>
                      }
                      {getModuleAccess('39') &&
                        <li className="slide">  <Link to='/accountEntryPassList'>
                          <a className="side-menu__item">
                            <span className="side-menu__label">
                              Material Entry pass
                            </span>
                          </a></Link>
                        </li>
                      }
                      {getModuleAccess('40') &&
                        <li className="slide">  <Link to='/accountExitPassList'>
                          <a className="side-menu__item">
                            <span className="side-menu__label">
                              Material Exit pass
                            </span>
                          </a></Link>
                        </li>
                      }
                      {getModuleAccess('7') &&
                        <li className="slide">  <Link to='/taxinvoiceexhibitors'>
                          <a className="side-menu__item">
                            <span className="side-menu__label">
                              Exhibitors
                            </span>
                          </a></Link>
                        </li>
                      }
                      {getModuleAccess('5') &&
                        <li className="slide">  <Link to='/ledgerList'>
                          <a className="side-menu__item">
                            <span className="side-menu__label">
                              Ledger
                            </span>
                          </a></Link>
                        </li>
                      }
                      {getModuleAccess('3') &&
                        <li className="slide">  <Link to='/proformalist'>
                          <a className="side-menu__item">
                            <span className="side-menu__label">
                              Proforma Invoice list
                            </span>
                          </a></Link>
                        </li>
                      }
                      {getModuleAccess('2') &&
                        <li className="slide">  <Link to='/receiptlist'>
                          <a className="side-menu__item">
                            <span className="side-menu__label">
                              Receipt
                            </span>
                          </a></Link>
                        </li>
                      }
                      {getModuleAccess('42') &&
                        <li className="slide">  <Link to='/refundList'>
                          <a className="side-menu__item">
                            <span className="side-menu__label">
                              Refund
                            </span>
                          </a></Link>
                        </li>
                      }
                      {getModuleAccess('4') &&
                        <li className="slide">  <Link to='/reminderEmails'>
                          <a className="side-menu__item">
                            <span className="side-menu__label">
                              Reminder E-Mail
                            </span>
                          </a></Link>
                        </li>
                      }
                      {getModuleAccess('43') &&
                        <li className="slide">
                          <Link to={'/stallPossessionChecklistList'}>
                            <a className="side-menu__item">
                              <span className="side-menu__label">
                                Stall Possession
                              </span>
                            </a>
                          </Link>
                        </li>
                      }
                      {getModuleAccess('29') &&
                        <li className="slide">  <Link to='/accountTally'>
                          <a className="side-menu__item">
                            <span className="side-menu__label">
                              Tally
                            </span>
                          </a></Link>
                        </li>
                      }
                      {getModuleAccess('44') &&
                        <li className="slide">  <Link to='/taxinvoicelist'>
                          <a className="side-menu__item">
                            <span className="side-menu__label">
                              Tax Invoice List
                            </span>
                          </a></Link>
                        </li>
                      }
                      {getModuleAccess('44') &&
                        <li className="slide">  <Link to='/visitorReceiptList'>
                          <a className="side-menu__item">
                            <span className="side-menu__label">
                              Visitor Receipt
                            </span>
                          </a></Link>
                        </li>
                      }
                      {getModuleAccess('45') &&
                        <li className="slide">  <Link to='/visitorTaxInvoiceList'>
                          <a className="side-menu__item">
                            <span className="side-menu__label">
                              Visitor Tax Invoice List
                            </span>
                          </a></Link>
                        </li>
                      }
                    </ul>
                  </div>
                </li>
              }

              {/* C - Circulars */}
              {getModuleAccess('14') &&
                <li className="slide">
                  <Link to={'/addcircular'}>
                    <a className="side-menu__item">
                      <span className="side-menu__label">
                        Circulars
                      </span>
                    </a>
                  </Link>
                </li>
              }

              {/* D - Daily Routine Checklist */}
              {getModuleAccess('46') &&
                <li className="slide">
                  <Link to={'/dailyRoutineChecklistList'}>
                    <a className="side-menu__item">
                      <span className="side-menu__label">
                        Daily Routine Checklist
                      </span>
                    </a>
                  </Link>
                </li>
              }

              {getModuleAccess('77') &&
                <li className="slide">
                  <Link to={'/dailyRoutineTaskList'}>
                    <a className="side-menu__item">
                      <span className="side-menu__label">
                        Daily Routine Tasklist
                      </span>
                    </a>
                  </Link>
                </li>
              }

              {/* E - Exhibitors */}
              {(getModuleAccess('9') || getModuleAccess('41')) &&
                <li className="slide">
                  <Link to={'/exhibitorlist'} >
                    <a className="side-menu__item">
                      <span className="side-menu__label">
                        Exhibitors
                      </span>
                    </a>
                  </Link>
                </li>
              }
              {/* F - Features */}
              {getModuleAccess('21') &&
                <li className="slide">
                  <Link to={'/features'}>
                    <a className="side-menu__item">
                      <span className="side-menu__label">
                        Features
                      </span>
                    </a>
                  </Link>
                </li>
              }
              {/* Feature Intimation */}
              <li className="slide">
                <Link to={'/featureIntimationList'}>
                  <a className="side-menu__item">
                    <span className="side-menu__label">
                      Notification
                    </span>
                  </a>
                </Link>
              </li>
              {/* H - Hotel Booking Form */}
              {getModuleAccess('50') &&
                <li className="slide">
                  <Link to={'/bookingFormList'}>
                    <a className="side-menu__item">
                      <span className="side-menu__label">
                        Hotel Booking Form
                      </span>
                    </a>
                  </Link>
                </li>
              }

              {/* H - Hotel Enquiry */}
              {(getModuleAccess('35') || getModuleAccess('51')) &&
                <li className="slide">
                  <Link to={'/hotelEnquiryList'}>
                    <a className="side-menu__item">
                      <span className="side-menu__label">
                        Hotel Enquiry
                      </span>
                    </a>
                  </Link>
                </li>
              }

              {/* M - Manage Area */}
              {getModuleAccess('20') &&
                <li className="slide">
                  <Link to={'/manageArea'}>
                    <a className="side-menu__item">
                      <span className="side-menu__label">
                        Manage Area
                      </span>
                    </a>
                  </Link>
                </li>
              }

              {(getModuleAccess('11') || getModuleAccess('52')) &&
                <li className="slide" >
                  <a style={{ marginLeft: '0px', paddingLeft: '0px' }}
                    className="side-menu__item"
                    data-bs-toggle="collapse"
                    href="#masters3"
                    aria-expanded="false"
                    aria-controls="masters3"
                  >
                    <span className="side-menu__label w-100 d-flex justify-content-between align-items-center">
                      Manual Forms
                      <i className="fa fa-angle-right drop-icon" aria-hidden="true" style={{ marginRight: "8px" }}></i>
                    </span>
                  </a>
                  <div className="collapse" id="masters3">
                    <ul className="flex-column sub-menu" style={{ marginRight: '0px' }}>

                      <>
                        {getModuleAccess('53') && < li className="slide">
                          <Link to={'/airConnectionApplicationAdmin'}>
                            <a className="side-menu__item">
                              <span className="side-menu__label">
                                Air Connection Application
                              </span>
                            </a>
                          </Link>
                        </li>}
                        {getModuleAccess('54') && <li className="slide">
                          <Link to={'/stallDesign_admin'}>
                            <a className="side-menu__item">
                              <span className="side-menu__label">
                                Booth Design Approval
                              </span>
                            </a>
                          </Link>
                        </li>}
                        {getModuleAccess('18') && <li className="slide">
                          <Link to={'/edirectoryAdmin'}>
                            <a className="side-menu__item">
                              <span className="side-menu__label">
                                E-Directory Approval
                              </span>
                            </a>
                          </Link>
                        </li>}
                        {(getModuleAccess('17')) && <li className="slide">
                          <Link to={'/exhibitorBadgesAdmin'}>
                            <a className="side-menu__item">
                              <span className="side-menu__label">
                                Exhibitor Badges Approval
                              </span>
                            </a>
                          </Link>
                        </li>}
                        {(getModuleAccess('55')) && <li className="slide">
                          <Link to={'/meetingRoomRequestFormAdmin'}>
                            <a className="side-menu__item">
                              <span className="side-menu__label">
                                Meeting Room Request Form
                              </span>
                            </a>
                          </Link>
                        </li>}
                        {(getModuleAccess('56')) && <li className="slide">
                          <Link to={'/powerConnectionAdmin'}>
                            <a className="side-menu__item">
                              <span className="side-menu__label">
                                Power Connection Approval
                              </span>
                            </a>
                          </Link>
                        </li>}
                        {getModuleAccess('12') && <li className="slide">
                          <Link to={'/visainvitation'}>
                            <a className="side-menu__item">
                              <span className="side-menu__label">
                                VA-Exhibitors
                              </span>
                            </a>
                          </Link>
                        </li>}
                        {getModuleAccess('57') && <li className="slide">
                          <Link to={'/brandingOpportunityAdmin'}>
                            <a className="side-menu__item">
                              <span className="side-menu__label">
                                Venue Branding & Advertisement
                              </span>
                            </a>
                          </Link>
                        </li>}
                        {getModuleAccess('58') && <li className="slide">
                          <Link to={'/waterConnectionAdmin'}>
                            <a className="side-menu__item">
                              <span className="side-menu__label">
                                Water Connection
                              </span>
                            </a>
                          </Link>
                        </li>}
                      </>

                    </ul>
                  </div>
                </li>
              }
              {/* {getModuleAccess('13') &&
                <li className="slide">
                  <Link to={'/visitorVisaInvitation'}>
                    <a className="side-menu__item"
                    >
                      <span className="side-menu__label">
                        {" "}
                         VA-Visitors
                      </span>
                    </a>
                  </Link>
                </li>
              } */}
              {/* M - Master */}
              {getModuleAccess('27') &&
                <li className="slide" >
                  <a style={{ marginLeft: '0px', paddingLeft: '0px' }}
                    className="side-menu__item"
                    data-bs-toggle="collapse"
                    href="#masterCollapse"
                    aria-expanded="false"
                    aria-controls="masterCollapse"
                  >
                    <span className="side-menu__label w-100 d-flex justify-content-between align-items-center">
                      Master
                      <i className="fa fa-angle-right drop-icon" aria-hidden="true" style={{ marginRight: "8px" }}></i>
                    </span>
                  </a>
                  <div className="collapse " id="masterCollapse">
                    <ul className="flex-column sub-menu" style={{ marginRight: '0px' }}>
                      {getModuleAccess('59') && <li className="slide">  <Link to='/attendeeTypeMasterList'>
                        <a className="side-menu__item">
                          <span className="side-menu__label">
                            Attendee Type
                          </span>
                        </a></Link>
                      </li>}
                      {getModuleAccess('60') && <li className="slide">  <Link to='/bankDetailsList'>
                        <a className="side-menu__item">
                          <span className="side-menu__label">
                            Bank Details
                          </span>
                        </a></Link>
                      </li>}
                      {getModuleAccess('61') && <li className="slide">  <Link to='/chapterList'>
                        <a className="side-menu__item">
                          <span className="side-menu__label">
                            Chapters
                          </span>
                        </a></Link>
                      </li>}
                      {getModuleAccess('62') && <li className="slide">  <Link to='/cityMasterList'>
                        <a className="side-menu__item">
                          <span className="side-menu__label">
                            City Master
                          </span>
                        </a></Link>
                      </li>}
                      {getModuleAccess('64') && <li className="slide">  <Link to='/ServiceDeliverableMaster'>
                        <a className="side-menu__item">
                          <span className="side-menu__label">
                            Deliverable Services
                          </span>
                        </a></Link>
                      </li>}
                      {getModuleAccess('65') && <li className="slide">  <Link to='/exhibitionMasterList'>
                        <a className="side-menu__item">
                          <span className="side-menu__label">
                            Exhibition
                          </span>
                        </a></Link>
                      </li>}
                      {getModuleAccess('66') && <li className="slide">  <Link to='/gstList'>
                        <a className="side-menu__item">
                          <span className="side-menu__label">
                            GST
                          </span>
                        </a></Link>
                      </li>}
                      {getModuleAccess('67') && <li className="slide">  <Link to='/gateMasterList'>
                        <a className="side-menu__item">
                          <span className="side-menu__label">
                            Gate
                          </span>
                        </a></Link>
                      </li>}
                      {getModuleAccess('68') && <li className="slide">  <Link to='/hallMasterList'>
                        <a className="side-menu__item">
                          <span className="side-menu__label">
                            Hall
                          </span>
                        </a></Link>
                      </li>}
                      {getModuleAccess('69') && <li className="slide">  <Link to='/industrySegmentMaster'>
                        <a className="side-menu__item">
                          <span className="side-menu__label">
                            Industry Segment
                          </span>
                        </a></Link>
                      </li>}
                      {getModuleAccess('70') && <li className="slide">  <Link to='/onlinePresenceList'>
                        <a className="side-menu__item">
                          <span className="side-menu__label">
                            Online Presence
                          </span>
                        </a></Link>
                      </li>}
                      {getModuleAccess('71') && <li className="slide">  <Link to='/purposeofVisitMaster'>
                        <a className="side-menu__item">
                          <span className="side-menu__label">
                            Purpose of Visit
                          </span>
                        </a></Link>
                      </li>}
                      {getModuleAccess('72') && <li className="slide">  <Link to='/roleMasterList'>
                        <a className="side-menu__item">
                          <span className="side-menu__label">
                            Role
                          </span>
                        </a></Link>
                      </li>}
                      {getModuleAccess('73') && <li className="slide">  <Link to='/stallMasterList'>
                        <a className="side-menu__item">
                          <span className="side-menu__label">
                            Stall
                          </span>
                        </a></Link>
                      </li>}
                      {getModuleAccess('74') && <li className="slide">  <Link to='/stateMasterList'>
                        <a className="side-menu__item">
                          <span className="side-menu__label">
                            State Master
                          </span>
                        </a></Link>
                      </li>}
                      {getModuleAccess('75') && <li className="slide">  <Link to='/visitorTypeMasterList'>
                        <a className="side-menu__item">
                          <span className="side-menu__label">
                            Visitor Type
                          </span>
                        </a></Link>
                      </li>}
                      {getModuleAccess('76') && <li className="slide">
                        <a style={{ marginLeft: '0px', paddingLeft: '0px' }}
                          className="side-menu__item"
                          data-bs-toggle="collapse"
                          href="#manualFormsMasterCollapse"
                          aria-expanded="false"
                          aria-controls="masterCollapse"
                        >
                          <span className="side-menu__label w-100 d-flex justify-content-between align-items-center">
                            Manual forms Master
                            <i className="fa fa-angle-right drop-icon" aria-hidden="true" style={{ marginRight: "8px" }}></i>
                          </span>
                        </a>
                        <div className="collapse " id="manualFormsMasterCollapse">
                          <ul className="flex-column sub-menu" style={{ marginRight: '0px' }}>
                            <li className="slide">  <Link to='/additionalFurnitureMaster'>
                              <a className="side-menu__item">
                                <span className="side-menu__label">
                                  Additional Furniture
                                </span>
                              </a></Link>
                            </li>
                            <li className="slide">  <Link to='/cateringServicesMasterList'>
                              <a className="side-menu__item">
                                <span className="side-menu__label">
                                  Catering Services
                                </span>
                              </a></Link>
                            </li>
                            <li className="slide">  <Link to='/housekeepingApplicationMasterList'>
                              <a className="side-menu__item">
                                <span className="side-menu__label">
                                  Cleaning & Housekeeping Services
                                </span>
                              </a></Link>
                            </li>
                            <li className="slide">  <Link to='/delegateMeetingMasterList'>
                              <a className="side-menu__item">
                                <span className="side-menu__label">
                                  Delegate Meeting
                                </span>
                              </a></Link>
                            </li>
                            <li className="slide">  <Link to='/hostAndHostessMasterList'>
                              <a className="side-menu__item">
                                <span className="side-menu__label">
                                  Host and Hostess
                                </span>
                              </a></Link>
                            </li>
                            <li className="slide">  <Link to='/internetConnectionMasterList'>
                              <a className="side-menu__item">
                                <span className="side-menu__label">
                                  Internet Service
                                </span>
                              </a></Link>
                            </li>
                            <li className="slide">  <Link to='/leadRetrivalConnectionMaster'>
                              <a className="side-menu__item">
                                <span className="side-menu__label">
                                  Lead Retrival
                                </span>
                              </a></Link>
                            </li>
                            <li className="slide">  <Link to='/liquorlicenseMaster'>
                              <a className="side-menu__item">
                                <span className="side-menu__label">
                                  Liquor License
                                </span>
                              </a></Link>
                            </li>
                            <li className="slide">  <Link to='/meetingRoomMasterList'>
                              <a className="side-menu__item">
                                <span className="side-menu__label">
                                  Meeting Room
                                </span>
                              </a></Link>
                            </li>
                            <li className="slide">  <Link to='/prAgencyMasterList'>
                              <a className="side-menu__item">
                                <span className="side-menu__label">
                                  PR Agency
                                </span>
                              </a></Link>
                            </li>
                            <li className="slide">  <Link to='/photographyAndVideographyMasterList'>
                              <a className="side-menu__item">
                                <span className="side-menu__label">
                                  Photography And Videography
                                </span>
                              </a></Link>
                            </li>
                            <li className="slide">  <Link to='/rentalAudioVideoMaster'>
                              <a className="side-menu__item">
                                <span className="side-menu__label">
                                  Rental Audio & Video
                                </span>
                              </a></Link>
                            </li>
                            <li className="slide">  <Link to='/securityApplicationMasterList'>
                              <a className="side-menu__item">
                                <span className="side-menu__label">
                                  Security Application
                                </span>
                              </a></Link>
                            </li>
                            <li className="slide">  <Link to='/travelAndHospitalityMasterList'>
                              <a className="side-menu__item">
                                <span className="side-menu__label">
                                  Travel & Hospitality
                                </span>
                              </a></Link>
                            </li>
                            <li className="slide">  <Link to='/brandingOpportunityMaster'>
                              <a className="side-menu__item">
                                <span className="side-menu__label">
                                  Venue Branding & Advertisement
                                </span>
                              </a></Link>
                            </li>
                            <li className="slide">  <Link to='/visitorMeetingMaster'>
                              <a className="side-menu__item">
                                <span className="side-menu__label">
                                  Visitor Meeting
                                </span>
                              </a></Link>
                            </li>
                          </ul>
                        </div>
                      </li>}
                    </ul>
                  </div>
                </li>
              }

              {/* M - Manual Forms Summary */}
              {getModuleAccess('11') &&
                <li className="slide">
                  <Link to={'/manualformsummary'}>
                    <a className="side-menu__item">
                      <span className="side-menu__label">
                        Manual Forms Summary
                      </span>
                    </a>
                  </Link>
                </li>
              }

              {/* O - Organizer Routine Tasklist */}


              {/* O - Organizer Tracker */}
              {getModuleAccess('78') &&
                <li className="slide">
                  <Link to='/organizerTrackerList'>
                    <a className="side-menu__item">
                      <span className="side-menu__label">
                        Organizer Tracker
                      </span>
                    </a>
                  </Link>
                </li>
              }
              {/* {
                getModuleAccess('36') &&
                <li className="slide">
                  <Link to={'/addDelegateCircular'}>
                    <a className="side-menu__item"
                    >
                      <span className="side-menu__label">
                        {" "}
                         Delegate Circulars
                      </span>
                    </a>
                  </Link>
                </li>
              }
              {getModuleAccess('35') &&
                <li className="slide" >
                  <a style={{ marginLeft: '0px', paddingLeft: '0px' }}
                    className="side-menu__item"
                    data-bs-toggle="collapse"
                    href="#DelegateMasterCollapse"
                    aria-expanded="false"
                    aria-controls="DelegateMasterCollapse"
                  >
                    <span className="side-menu__label w-100 d-flex justify-content-between align-items-center">
                      Delegate Master
                      <i className="fa fa-angle-right drop-icon" aria-hidden="true" style={{ marginRight: "8px" }}></i>
                    </span>
                  </a>
                  <div className="collapse " id="DelegateMasterCollapse">
                    <ul className="flex-column sub-menu" style={{ marginRight: '0px' }}>
                      <li className="slide">
                        <Link to='/delegateInvitationType'>
                          <a className="side-menu__item"
                          >
                            <span className="side-menu__label">
                              {" "}
                               Invitation Type
                            </span>
                          </a></Link>
                      </li>
                      <li className="slide">
                        <Link to='/delegateInvitationEventList'>
                          <a className="side-menu__item"
                          >
                            <span className="side-menu__label">
                              {" "}
                               Invitation Event
                            </span>
                          </a></Link>
                      </li>
                    </ul>
                  </div>
                </li>
              } */}
              {/* R - Reports */}
              {getModuleAccess('15') &&
                <li className="slide">
                  <Link to={'/reportList'}>
                    <a className="side-menu__item">
                      <span className="side-menu__label">
                        Reports
                      </span>
                    </a>
                  </Link>
                </li>
              }

              {/* S - Service Partner */}
              {(getModuleAccess('23') || getModuleAccess('80')) &&
                <li className="slide" >
                  <a style={{ marginLeft: '0px', paddingLeft: '0px' }}
                    className="side-menu__item"
                    data-bs-toggle="collapse"
                    href="#masters2"
                    aria-expanded="false"
                    aria-controls="masters2"
                  >
                    <span className="side-menu__label w-100 d-flex justify-content-between align-items-center">
                      Service Partner
                      <i className="fa fa-angle-right drop-icon" aria-hidden="true" style={{ marginRight: "8px" }}></i>
                    </span>
                  </a>
                  <div className="collapse " id="masters2">
                    <ul className="flex-column sub-menu" style={{ marginRight: '0px' }}>
                      <>
                        {getModuleAccess('81') &&
                          <li className="slide">
                            <Link to={'/VendorPlan'}>
                              <a className="side-menu__item">
                                <span className="side-menu__label">
                                  Plan and Timeline
                                </span>
                              </a>
                            </Link>
                          </li>}
                        {getModuleAccess('82') &&
                          <li className="slide">
                            <Link to={'/vendorWorkOrderList'}>
                              <a className="side-menu__item">
                                <span className="side-menu__label">
                                  Scope of work
                                </span>
                              </a>
                            </Link>
                          </li>}
                        {getModuleAccess('83') && <li className="slide">
                          <Link to={'/VendorRegistrationList'}>
                            <a className="side-menu__item">
                              <span className="side-menu__label">
                                Service Partner <br />Registration
                              </span>
                            </a>
                          </Link>
                        </li>}
                      </>

                    </ul>
                  </div>
                </li>
              }
              {getModuleAccess('84') &&
                <li className="slide">
                  <Link to={'/sponsorshipList'}>
                    <a className="side-menu__item">
                      <span className="side-menu__label">
                        Sponsorship
                      </span>
                    </a>
                  </Link>
                </li>
              }
              {/* U - Users */}
              {getModuleAccess('28') &&
                <li className="slide">
                  <Link to={'/userList'}>
                    <a className="side-menu__item">
                      <span className="side-menu__label">
                        Users
                      </span>
                    </a>
                  </Link>
                </li>
              }

              {/* V - VA-Visitors */}
              {getModuleAccess('13') &&
                <li className="slide">
                  <Link to={'/visitorVisaInvitation'}>
                    <a className="side-menu__item">
                      <span className="side-menu__label">
                        VA-Visitors
                      </span>
                    </a>
                  </Link>
                </li>
              }

              {/* V - Visitors */}
              {getModuleAccess('10') &&
                <li className="slide">
                  <Link to={'/visitorslist'} >
                    <a className="side-menu__item">
                      <span className="side-menu__label">
                        Visitors
                      </span>
                    </a>
                  </Link>
                </li>
              }

              {/* V - Visitors Circulars */}
              {getModuleAccess('24') &&
                <li className="slide">
                  <Link to={'/addVisitorCircular'}>
                    <a className="side-menu__item">
                      <span className="side-menu__label">
                        Visitors Circulars
                      </span>
                    </a>
                  </Link>
                </li>
              }
              {/* {getModuleAccess('16') &&
                <li className="slide">
                  <Link to={'/fasciaadmin'}>
                    <a className="side-menu__item"
                    >
                      <span className="side-menu__label">
                        {" "}
                         Fascia Approval
                      </span>
                    </a>
                  </Link>
                </li>
              }
              {getModuleAccess('17') &&
                <li className="slide">
                  <Link to={'/exhibitorBadgesAdmin'}>
                    <a className="side-menu__item"
                    >
                      <span className="side-menu__label">
                        {" "}
                         Exhibitor Badges Approval
                      </span>
                    </a>
                  </Link>
                </li>
              } */}

              {/* {getModuleAccess('18') &&
                <li className="slide">
                  <Link to={'/edirectoryAdmin'}>
                    <a className="side-menu__item"
                    >
                      <span className="side-menu__label">
                        {" "}
                         E-Directory Approval
                      </span>
                    </a>
                  </Link>
                </li>
              } */}

              {/* <li className="slide">
                <Link to={'/powerreqadmin'}>
                  <a className="side-menu__item"
                  >
                    <span className="side-menu__label">
                      {" "}
                       Power Connection Approval
                    </span>
                  </a>
                </Link>
              </li> */}

              {/* <li className="slide" style={{cursor:'pointer'}}   data-toggle="modal" data-target="#logout" onClick={toggleModal}>
                  <a className="side-menu__item"
                   >
                    <span className="side-menu__label">
                      {" "}
                       Log Out

                      
                    </span>
                  </a>
              </li> */}

              {/*  <li class="slide">
                          <a class="side-menu__item has-link" data-bs-toggle="slide" href="#"><i class="side-menu__icon fe fe-activity "></i><span class="side-menu__label">Survey</span></a>
                      </li> */}
            </ul>
            <div className="slide-right" id="slide-right">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="#7b8191"
                width={24}
                height={24}
                viewBox="0 0 24 24"
              >
                <path d="M10.707 17.707 16.414 12l-5.707-5.707-1.414 1.414L13.586 12l-4.293 4.293z" />
              </svg>
            </div>
          </div>

          <div className="ps__rail-x" style={{ left: '0', bottom: '0' }}>
            <div className="ps__thumb-x" tabIndex={0} style={{ left: '0', width: '0' }} />
          </div>
          <div className="ps__rail-y" style={{ top: '0', right: '0', height: '625px' }}>
            <div
              className="ps__thumb-y"
              tabIndex={0}
              style={{ top: '0', height: '554px' }}
            />
          </div>
        </div>
      </div >
    </>
  );
}
export default ExhibitionDrawer;